import React from 'react';

import IPlan from '../interfaces/models/plan.interface';

export const Plans: IPlan[] = [
  {
    name: 'CHATBOT_FREE',
    headerTitle: 'PlansConstant/t-01',
    headerTitleClass: 'btn btn-outline-secondary',
    title: 'PlansConstant/t-02',
    button: 'PlansConstant/btn-01',
    is_user_new_button: 'PlansConstant/btn-01',
    buttonClass: 'nav-btn',
    isDiscount: true,
    discountDescription: 'PlansConstant/des-01',
    discountIcon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.26044 23.0854L21.6397 2.39572L19.7387 0.798828L17.0989 3.94141H4C2.897 3.94141 2 4.83841 2 5.94141V17.9414C2 18.9356 2.7288 19.7625 3.68035 19.9159L2.35938 21.4885L4.26044 23.0854ZM5.33892 17.9414H4V11.9414H10.3789L5.33892 17.9414ZM13.7389 7.94141L15.4189 5.94141H4V7.94141H13.7389ZM20 7.94141H18.569L15.2646 11.9414H20.001L20.002 17.9414H10.3081L8.65592 19.9414H20C21.103 19.9414 22 19.0444 22 17.9414V5.94141C22 5.38304 21.7701 4.87746 21.4 4.51432L20 6.2091V7.94141Z"
          fill="#889096"
        />
      </svg>
    ),
    priceDescription: '$ 0',
    price: 0,
    isMonthly: true,
    features: [
      {
        name: 'PlansConstant/des-02',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-03',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-08',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-10',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-071',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-01',
        category: '',
        valueType: '',
      },
    ],
  },
  {
    name: 'CHATBOT_FREE',
    title: 'PlansConstant/t-02',
    headerTitle: 'PlansConstant/t-01',
    headerTitleClass: 'btn btn-outline-secondary',
    isDiscount: true,
    discountDescription: 'PlansConstant/des-01',
    discountIcon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.26044 23.0854L21.6397 2.39572L19.7387 0.798828L17.0989 3.94141H4C2.897 3.94141 2 4.83841 2 5.94141V17.9414C2 18.9356 2.7288 19.7625 3.68035 19.9159L2.35938 21.4885L4.26044 23.0854ZM5.33892 17.9414H4V11.9414H10.3789L5.33892 17.9414ZM13.7389 7.94141L15.4189 5.94141H4V7.94141H13.7389ZM20 7.94141H18.569L15.2646 11.9414H20.001L20.002 17.9414H10.3081L8.65592 19.9414H20C21.103 19.9414 22 19.0444 22 17.9414V5.94141C22 5.38304 21.7701 4.87746 21.4 4.51432L20 6.2091V7.94141Z"
          fill="#889096"
        />
      </svg>
    ),
    button: 'PlansConstant/btn-01',
    is_user_new_button: 'PlansConstant/btn-01',
    buttonClass: 'nav-btn',
    priceDescription: '$ 0',
    price: 0,
    isMonthly: false,
    features: [
      {
        name: 'PlansConstant/des-02',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-03',
        category: '',
        valueType: '',
      },

      {
        name: 'PlansConstant/des-10',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-071',
        category: '',
        valueType: '',
      },
      {
        name: 'PlansConstant/des-01',
        category: '',
        valueType: '',
      },
    ],
  },
  {
    name: 'CHATBOT_BASIC_MONTHLY',
    title: 'PlansConstant/t-03',
    button: 'PlansConstant/btn-01',
    headerTitle: 'PlansConstant/t-04',
    headerTitleClass: 'btn btn-secondary',
    is_user_new_button: 'PlansConstant/btn-01',
    icon: (
      <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="42" cy="42" r="42" fill="#F0F4FF" />
        <path
          d="M49.7787 26.25H34.2212C33.6175 26.25 33.0557 26.5615 32.7355 27.0725L26.6875 36.75H57.3125L51.2645 27.0725C51.1067 26.8209 50.8876 26.6135 50.6277 26.4696C50.3679 26.3258 50.0758 26.2502 49.7787 26.25ZM40.705 58.0755C40.869 58.256 41.069 58.4001 41.292 58.4988C41.515 58.5975 41.7561 58.6484 42 58.6484C42.2439 58.6484 42.485 58.5975 42.708 58.4988C42.931 58.4001 43.131 58.256 43.295 58.0755L59.5 40.25H24.5L40.705 58.0755Z"
          fill="#4167DA"
        />
      </svg>
    ),
    buttonClass: 'nav-btn',
    isDiscount: false,
    discountDescription: '',

    priceDescription: 'PlansConstant/des-04',
    price: 19,
    isMonthly: true,
    features: [
      {
        name: 'PlansConstant/t-05',
      },
      {
        name: 'PlansConstant/des-17',
      },
      {
        name: 'PlansConstant/des-11',
      },
      {
        name: 'PlansConstant/des-14',
      },
      {
        name: 'PlansConstant/des-091',
      },
      {
        name: 'PlansConstant/t-06',
      },
      {
        name: 'PlansConstant/t-07',
      },
      {
        name: 'PlansConstant/t-08',
      },
      {
        name: 'PlansConstant/des-18',
      },
      {
        name: 'PlansConstant/des-181',
      },
      {
        name: 'PlansConstant/des-20',
      },
      {
        name: 'PlansConstant/des-201',
      },
      {
        name: 'PlansConstant/des-202',
      },
      {
        name: 'PlansConstant/des-203',
      },
      {
        name: 'PlansConstant/des-204',
      },
      {
        name: 'PlansConstant/des-205',
      },
    ],
  },
  {
    name: 'CHATBOT_BASIC_ANNUAL',
    title: 'PlansConstant/t-03',
    button: 'PlansConstant/btn-01',
    headerTitle: 'PlansConstant/t-04',
    headerTitleClass: 'btn btn-secondary',
    is_user_new_button: 'PlansConstant/btn-01',
    buttonClass: 'nav-btn',
    isDiscount: true,
    discountDescription: 'PlansConstant/des-04',
    discountLine: true,
    icon: (
      <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="42" cy="42" r="42" fill="#F0F4FF" />
        <path
          d="M49.7787 26.25H34.2212C33.6175 26.25 33.0557 26.5615 32.7355 27.0725L26.6875 36.75H57.3125L51.2645 27.0725C51.1067 26.8209 50.8876 26.6135 50.6277 26.4696C50.3679 26.3258 50.0758 26.2502 49.7787 26.25ZM40.705 58.0755C40.869 58.256 41.069 58.4001 41.292 58.4988C41.515 58.5975 41.7561 58.6484 42 58.6484C42.2439 58.6484 42.485 58.5975 42.708 58.4988C42.931 58.4001 43.131 58.256 43.295 58.0755L59.5 40.25H24.5L40.705 58.0755Z"
          fill="#4167DA"
        />
      </svg>
    ),

    priceDescription: 'PlansConstant/des-05',
    price: 156,
    isMonthly: false,
    features: [
      {
        name: 'PlansConstant/t-05',
      },
      {
        name: 'PlansConstant/des-17',
      },
      {
        name: 'PlansConstant/des-11',
      },
      {
        name: 'PlansConstant/des-14',
      },
      {
        name: 'PlansConstant/des-091',
      },
      {
        name: 'PlansConstant/t-06',
      },
      {
        name: 'PlansConstant/t-07',
      },
      {
        name: 'PlansConstant/t-08',
      },
      {
        name: 'PlansConstant/des-18',
      },
      {
        name: 'PlansConstant/des-181',
      },
      {
        name: 'PlansConstant/des-20',
      },
      {
        name: 'PlansConstant/des-201',
      },
      {
        name: 'PlansConstant/des-202',
      },
      {
        name: 'PlansConstant/des-203',
      },
      {
        name: 'PlansConstant/des-204',
      },
      {
        name: 'PlansConstant/des-205',
      },
    ],
  },
  {
    name: 'CHATBOT_ADVANCED_MONTHLY',
    title: 'PlansConstant/t-10',
    button: 'PlansConstant/btn-01',
    headerTitle: 'PlansConstant/t-11',
    headerTitleClass: 'btn btn-secondary',
    is_user_new_button: 'PlansConstant/btn-01',
    buttonClass: 'nav-btn nav-btn-light color-sevenColor',
    isDiscount: false,
    icon: (
      <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="42" cy="42" r="42" fill="#F0F4FF" />
        <path
          d="M50.75 38.5V31.5L42 38.5V31.5L33.25 38.5V28H24.5V56H59.5V31.5L50.75 38.5ZM36.75 50.75H33.25V45.5H36.75V50.75ZM45.5 50.75H42V45.5H45.5V50.75ZM54.25 50.75H50.75V45.5H54.25V50.75Z"
          fill="#4167DA"
        />
      </svg>
    ),

    discountDescription: '',
    priceDescription: 'PlansConstant/des-06',
    price: 39,
    isMonthly: true,
    features: [
      {
        name: 'PlansConstant/t-15',
      },
      {
        name: 'PlansConstant/des-171',
      },
      {
        name: 'PlansConstant/des-12',
      },
      {
        name: 'PlansConstant/des-15',
      },
      {
        name: 'PlansConstant/des-092',
      },
      {
        name: 'PlansConstant/t-06',
      },
      {
        name: 'PlansConstant/t-07',
      },
      {
        name: 'PlansConstant/t-08',
      },
      {
        name: 'PlansConstant/des-19',
      },
      {
        name: 'PlansConstant/des-191',
      },
      {
        name: 'PlansConstant/des-20',
      },
      {
        name: 'PlansConstant/des-201',
      },
      {
        name: 'PlansConstant/des-202',
      },
      {
        name: 'PlansConstant/des-203',
      },
      {
        name: 'PlansConstant/des-204',
      },
      {
        name: 'PlansConstant/des-205',
      },
      {
        name: 'PlansConstant/des-21',
      },
      {
        name: 'PlansConstant/des-22',
      },
      {
        name: 'PlansConstant/des-221',
      },
    ],
  },
  {
    name: 'CHATBOT_ADVANCED_ANNUAL',
    title: 'PlansConstant/t-10',
    button: 'PlansConstant/btn-01',
    headerTitle: 'PlansConstant/t-11',
    headerTitleClass: 'btn btn-secondary',
    icon: (
      <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="42" cy="42" r="42" fill="#F0F4FF" />
        <path
          d="M50.75 38.5V31.5L42 38.5V31.5L33.25 38.5V28H24.5V56H59.5V31.5L50.75 38.5ZM36.75 50.75H33.25V45.5H36.75V50.75ZM45.5 50.75H42V45.5H45.5V50.75ZM54.25 50.75H50.75V45.5H54.25V50.75Z"
          fill="#4167DA"
        />
      </svg>
    ),
    is_user_new_button: 'PlansConstant/btn-01',
    buttonClass: 'nav-btn nav-btn-light color-sevenColor',
    isDiscount: true,
    discountDescription: 'PlansConstant/des-06',
    discountLine: true,

    priceDescription: 'PlansConstant/des-07',
    price: 312,
    isMonthly: false,
    features: [
      {
        name: 'PlansConstant/t-15',
      },
      {
        name: 'PlansConstant/des-171',
      },
      {
        name: 'PlansConstant/des-12',
      },
      {
        name: 'PlansConstant/des-15',
      },
      {
        name: 'PlansConstant/des-092',
      },
      {
        name: 'PlansConstant/t-06',
      },
      {
        name: 'PlansConstant/t-07',
      },
      {
        name: 'PlansConstant/t-08',
      },
      {
        name: 'PlansConstant/des-19',
      },
      {
        name: 'PlansConstant/des-191',
      },
      {
        name: 'PlansConstant/des-20',
      },
      {
        name: 'PlansConstant/des-201',
      },
      {
        name: 'PlansConstant/des-202',
      },
      {
        name: 'PlansConstant/des-203',
      },
      {
        name: 'PlansConstant/des-204',
      },
      {
        name: 'PlansConstant/des-205',
      },
      {
        name: 'PlansConstant/des-21',
      },
      {
        name: 'PlansConstant/des-22',
      },
      {
        name: 'PlansConstant/des-221',
      },
    ],
  },

  // New Large account
  {
    name: 'CHATBOT_LARGE',
    title: 'PlansConstant/largeAccount/key1',
    button: 'PlansConstant/largeAccount/key2',
    headerTitle: 'PlansConstant/largeAccount/key3',
    headerTitleClass: 'btn btn-secondary',
    // icon: (
    //   <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <circle cx="42" cy="42" r="42" fill="#F0F4FF" />
    //     <path
    //       d="M50.75 38.5V31.5L42 38.5V31.5L33.25 38.5V28H24.5V56H59.5V31.5L50.75 38.5ZM36.75 50.75H33.25V45.5H36.75V50.75ZM45.5 50.75H42V45.5H45.5V50.75ZM54.25 50.75H50.75V45.5H54.25V50.75Z"
    //       fill="#4167DA"
    //     />
    //   </svg>
    // ),
    is_user_new_button: 'PlansConstant/largeAccount/key4',
    buttonClass: 'nav-btn nav-btn-light color-sevenColor',
    isDiscount: true,
    discountDescription: 'PlansConstant/largeAccount/key5',
    discountLine: true,

    priceDescription: 'PlansConstant/largeAccount/key6',
    price: 0,
    isMonthly: false,
    features: [
      {
        name: 'PlansConstant/largeAccount/features/key1',
      },
      {
        name: 'PlansConstant/largeAccount/features/key2',
      },
      {
        name: 'PlansConstant/largeAccount/features/key3',
      },
      {
        name: 'PlansConstant/largeAccount/features/key4',
      },
      {
        name: 'PlansConstant/largeAccount/features/key5',
      },
      {
        name: 'PlansConstant/largeAccount/features/key6',
      },
      {
        name: 'PlansConstant/largeAccount/features/key7',
      },
      {
        name: 'PlansConstant/largeAccount/features/key8',
      },
      {
        name: 'PlansConstant/largeAccount/features/key8-1',
      },
      {
        name: 'PlansConstant/largeAccount/features/key9',
      },
      {
        name: 'PlansConstant/largeAccount/features/key10',
      },
      {
        name: 'PlansConstant/largeAccount/features/key11',
      },
      {
        name: 'PlansConstant/largeAccount/features/key12',
      },
      {
        name: 'PlansConstant/largeAccount/features/key13',
      },
      {
        name: 'PlansConstant/largeAccount/features/key14',
      },
      {
        name: 'PlansConstant/largeAccount/features/key15',
      },
    ],
  },
  {
    name: 'CHATBOT_LARGE',
    title: 'PlansConstant/largeAccount/key1',
    button: 'PlansConstant/largeAccount/key2',
    headerTitle: 'PlansConstant/largeAccount/key3',
    headerTitleClass: 'btn btn-secondary',
    // icon: (
    //   <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <circle cx="42" cy="42" r="42" fill="#F0F4FF" />
    //     <path
    //       d="M50.75 38.5V31.5L42 38.5V31.5L33.25 38.5V28H24.5V56H59.5V31.5L50.75 38.5ZM36.75 50.75H33.25V45.5H36.75V50.75ZM45.5 50.75H42V45.5H45.5V50.75ZM54.25 50.75H50.75V45.5H54.25V50.75Z"
    //       fill="#4167DA"
    //     />
    //   </svg>
    // ),
    is_user_new_button: 'PlansConstant/largeAccount/key4',
    buttonClass: 'nav-btn nav-btn-light color-sevenColor',
    isDiscount: true,
    discountDescription: 'PlansConstant/largeAccount/key5',
    discountLine: true,

    priceDescription: 'PlansConstant/largeAccount/key6',
    price: 0,
    isMonthly: true,
    features: [
      {
        name: 'PlansConstant/largeAccount/features/key1',
      },
      {
        name: 'PlansConstant/largeAccount/features/key2',
      },
      {
        name: 'PlansConstant/largeAccount/features/key3',
      },
      {
        name: 'PlansConstant/largeAccount/features/key4',
      },
      {
        name: 'PlansConstant/largeAccount/features/key5',
      },
      {
        name: 'PlansConstant/largeAccount/features/key6',
      },
      {
        name: 'PlansConstant/largeAccount/features/key7',
      },
      {
        name: 'PlansConstant/largeAccount/features/key8',
      },
      {
        name: 'PlansConstant/largeAccount/features/key8-1',
      },
      {
        name: 'PlansConstant/largeAccount/features/key9',
      },
      {
        name: 'PlansConstant/largeAccount/features/key10',
      },
      {
        name: 'PlansConstant/largeAccount/features/key11',
      },
      {
        name: 'PlansConstant/largeAccount/features/key12',
      },
      {
        name: 'PlansConstant/largeAccount/features/key13',
      },
      {
        name: 'PlansConstant/largeAccount/features/key14',
      },
    ],
  },
];

export const ApsumoPlans: any[] = [
  {
    name: 'LB_APPSUMO_TIER1',
    title: 'AppSumo (Tier 1)',
  },
  {
    name: 'LB_APPSUMO_TIER2',
    title: 'AppSumo (Tier 2)',
  },
  {
    name: 'LB_APPSUMO_TIER3',
    title: 'AppSumo (Tier 3)',
  },
];

const planCodesMapper: Record<string, string> = {
  CHATBOT_FREE: 'FREE',
  CHABOTC_LSH3RKBR5W: 'FREE_EU',
  CHATBOT_BASIC_MONTHLY: 'BASIC_MONTHLY',
  CHABOM_YXN1LILRWY: 'BASIC_MONTHLY_EU',
  CHATBOT_BASIC_ANNUAL: 'BASIC_ANNUAL',
  CHABOA_02OW2E8C4U: 'BASIC_ANNUAL_EU',
  CHATBOT_BASIC_ANNUAL_TRIAL: 'BASIC_ANNUAL_TRIAL',
  CHATBOT_ADVANCED_MONTHLY: 'ADVANCED_MONTHLY',
  CHABOM_OSMFCYDT0V: 'ADVANCED_MONTHLY_EU',
  CHATBOT_ADVANCED_ANNUAL: 'ADVANCED_ANNUAL',
  CHABOA_B42CDBJP56: 'ADVANCED_ANNUAL_EU',
  CHATBOT_ADVANCED_ANNUAL_TRIAL: 'ADVANCED_ANNUAL_TRIAL',
  CHABOA_Y8O3FH61GW: 'ENTERPRISE_ANNUAL_EU',
  CHABOM_5Q5FNDRELE: 'ENTERPRISE_ANNUAL',
  CHABOM_TX5B3V1J9V: 'ENTERPRISE_MONTHLY_EU',
  CHABOM_8F83AHUURU: 'ENTERPRISE_MONTHLY',
  LB_APPSUMO_TIER1: 'APPSUMO_TIER_1',
  LB_APPSUMO_TIER2: 'APPSUMO_TIER_2',
  LB_APPSUMO_TIER3: 'APPSUMO_TIER_3 ',
  UNLOCK_ALL_WELCOME: 'WELCOME',
};

const getPlanName = (planCode: string) => {
  return planCodesMapper[planCode];
};

export const getCurrencyPlanWithPlanCode = (planCode: string) => {
  const planName = getPlanName(planCode);
  if (planName) {
    const name = planName.split('_')[planName.split('_').length - 1];
    if (name == 'EU') {
      return 'EU';
    }
  }
  return 'USD';
};
